<template>
    <v-card>
        <v-card-title>
            {{$t('Add Guests')}}
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="$router.push({name: 'guest-template', params: {isTemplate: 1}})">
                Excel Template
                <v-icon right>mdi-download</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <!-- <v-row>
                    <v-select
                        outlined
                        :label="$t('Event')"
                        :placeholder="$t('Event')"
                        v-model="eventSelected"
                        :items="eventOptions"></v-select>
                </v-row>
                <v-row>
                    <v-select
                        outlined
                        :label="$t('guest.company')"
                        :placeholder="$t('guest.company')"
                        v-model="companySelected"
                        :items="companyOptions"></v-select>
                </v-row>
                <v-row>
                    <v-select
                        outlined
                        label="Username"
                        v-model="usernameCol"
                        :items="usernameCol_items"></v-select>
                </v-row>
                <v-row>
                    <v-select
                        outlined
                        label="Password"
                        v-model="passwordCol"
                        :items="passwordCol_items"></v-select>
                </v-row> -->
                <v-row>
                    <v-file-input
                        outlined
                        prepend-icon=""
                        prepend-inner-icon="$file"
                        accept=".xlsx, .xls, .csv"
                        label="Import File"
                        placeholder="Select..."
                        @change="uploadExcel"></v-file-input>
                </v-row>
                <v-row>
                    <v-chip
                        label
                        small
                        @click="addGuest">
                        <v-icon>mdi-account-plus</v-icon>
                    </v-chip>
                    <v-chip
                        label
                        small
                        @click="removeGuest">
                        <v-icon>mdi-account-minus</v-icon>
                    </v-chip>
                </v-row>
                <v-row>
                    <canvas-datagrid
                        :data.prop="excelData"
                        @rendercell="loadDataCheck"
                        @beforesortcolumn="beforeSortColumn"
                        style="height: 300px"
                        id="excelGrid"></canvas-datagrid>
                </v-row>
                <v-row>
                    <br>
                </v-row>
                <v-row>
                    <v-btn color="primary" @click="importCheck">
                        {{$t('guest.create')}}
                    </v-btn>
                </v-row>
            </v-container>
        
        </v-card-text>
            
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <v-dialog v-model="dialog" scrollable max-width="640px">
            <v-card>
                <v-card-text style="height: 360px; padding: 15px" v-html="dialogMsg">
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <RouterView></RouterView>
    </v-card>
</template>

<script>
    import {computed, ref, onMounted, onBeforeUnmount} from '@vue/composition-api';
    
    import XLSX from 'xlsx';
    import CanvasDatagrid from 'canvas-datagrid';
    import {useGet} from "feathers-vuex";
    import _ from 'lodash';
    import eConfig from "../../evention-config.js"

    export default {
        name: 'GuestBatchAdd',
        setup(props, {root}) {
            const {EventGuest, Company, Event} = root.$FeathersVuex.api;

            const excelInputEle = ref([]);
            
            onMounted(() => {
                document.getElementById('excelGrid').style.width = '100%';
                document.getElementById('excelGrid').controlInput.onblur = () => {
                    if (document.getElementById('excelGrid') && document.getElementById('excelGrid').input) {
                        excelInputEle.value = document.getElementById('excelGrid').input

                        document.getElementById('excelGrid').input.onblur = () => {
                            if (document.getElementById('excelGrid')) {
                                document.getElementById('excelGrid').endEdit(false);
                            }
                        }
                    }
                };
            });

            onBeforeUnmount(() => {
                if (excelInputEle.value) {
                    excelInputEle.value.remove()
                }
            });

            const eventId = computed(() => root.$route.params.eventId);
            const {item: event} = useGet({model: Event, id: eventId});
            
            const companyId = computed(() => (event.value && event.value.companyId));
            const {item: company} = useGet({model: Company, id: companyId});
            
            const eventSelected = computed(() => eventId);
            const eventOptions = computed(() => event.value ? [{text: event.value.name, value: event.value.id}] : []);
            
            const companySelected = computed(() => companyId);
            const companyOptions = computed(() => company.value ? [{text: company.value.name, value: company.value.id}] : []);
            
            const overlay = ref(false);
            
            const dialog = ref(false);
            const dialogMsg = ref('');
            
            const dbColMapping = eConfig.guest.dbColMapping;
            
            const colOptions = ref(Object.keys(dbColMapping).map((col) => {return {text: col, value: col}}));
            
            const readXLSX = (file) => {
                let nameSplit = file.name.split('.');
                let format = nameSplit[nameSplit.length - 1];
                if (!['xls', 'xlsx', 'csv'].includes(format)) {
                    return false;
                }
                return new Promise((resolve) => {
                    let reader = new FileReader();
                    reader.readAsBinaryString(file);
                    reader.onload = function (evt) {
                        let data = evt.target.result;
                        var workbook = XLSX.read(data, {type: 'binary'});
                        let outdata = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {defval: ''});
                        resolve(outdata);
                    }
                });
            }

            const uploadExcel = async (f) => {
                if (f) {
                    const outdata = await readXLSX(f);
                    excelData.value = outdata;
                } else {
                    excelData.value = JSON.parse(JSON.stringify(excelData_init));
                    // usernameCol.value = 'Email';
                    // passwordCol.value = '';
                }
                
                if (excelData.value && excelData.value.length >= 1) {
                    colOptions.value = Object.keys(excelData.value[0]).map((col) => {return {text: col, value: col}});
                }
                return false;
            };
            
            const checkValue = (header, value) => {
                if (header == 'First Name' && value.toString().trim() == '') {
                    return false;
                }
                if (header == 'Email' && value !== 'Email' && !/^[^@]+@[^@]+\.[^@]+$/.test(value)) {
                    return false;
                }
                // if (header == usernameCol.value && !/^[^\s]+(?: [^\s]+)*$/.test(value)) { // no trailing spaces and extra spaces
                //     return false;
                // }
                if (header == 'Username' && !/^[^\s]+(?: [^\s]+)*$/.test(value)) { // no trailing spaces and extra spaces
                    return false;
                }
                if (header == 'Local/Oversea(local/oversea)' && value !== header && !['', 'local', 'oversea'].includes(value.toString().toLowerCase().trim())) {
                    return false;
                }
                if (header == 'Private account(yes/no)' && value !== header && !['', 'yes', 'no'].includes(value.toString().toLowerCase().trim())) {
                    return false;
                }
                if (header == 'Notification(yes/no)' && value !== header && !['', 'yes', 'no'].includes(value.toString().toLowerCase().trim())) {
                    return false;
                }
                return true;
            };
            
            const loadDataCheck = (e) => {
                // this function also check the header field
                if (!_.isEqual(excelData.value, excelData_init)) {
                    if (!checkValue(e.cell.header.name, e.cell.value)) {
                        e.ctx.fillStyle = '#FFAAAA';
                    }
                }
            };
            
            const importCheck = async () => {
                // console.log('Company: '+companySelected.value.value);
                // console.log('Event: '+eventSelected.value.value);
                // console.log('Username: '+usernameCol.value);
                // console.log('Password: '+passwordCol.value);
                // console.log('excelData.value: ---');
                // console.log(excelData.value);
                // console.log('---');
                
                // if (!usernameCol.value) {
                //     root.$store.dispatch('showSnackBar', 'Please select column for username');
                //     return false;
                // }
                
                if (!excelData.value[0].hasOwnProperty('Username') || !excelData.value[0].hasOwnProperty('First Name') || !excelData.value[0].hasOwnProperty('Email') || !excelData.value[0].hasOwnProperty('Qrcode')) {
                    root.$store.dispatch('showSnackBar', 'Invalid Guest List Format');
                    return false;
                }
                
                for (let y = 0; y < excelData.value.length; y++) {
                    let rowValid = Object.keys(excelData.value[y]).every((header) => { return checkValue(header, excelData.value[y][header]); });
                    if (!rowValid) {
                        root.$store.dispatch('showSnackBar', 'Row #' + (y + 1) + ' is not valid');
                        return;
                    }
                }
                
                let duplicatesUsername = _.difference(excelData.value, _.uniqBy(excelData.value, 'Username'), 'Username');
                if (duplicatesUsername.length >= 1) {
                    root.$store.dispatch('showSnackBar', 'Duplicate Username: ' + duplicatesUsername[0]['Username']);
                    return false;
                }
                
                let duplicatesQrcode = _.difference(excelData.value, _.uniqBy(excelData.value, 'Qrcode'), 'Qrcode');
                if (duplicatesQrcode.filter((row) => (row.Qrcode !== '')).length >= 1) {
                    root.$store.dispatch('showSnackBar', 'Duplicate QR Code: ' + duplicatesQrcode[0]['Qrcode']);
                    return false;
                }
                
                overlay.value = true;
                
                let count = 0;
                let errorCount = 0;
                let errorMsg = '';
                
                for (let g of excelData.value) {
                    // post process data
                    if (g.hasOwnProperty('Username') && g['Username']) g['Username'] = g['Username'].toString().toLowerCase().replace(/\s/g, '');
                    if (g.hasOwnProperty('Email') && g['Email']) g['Email'] = g['Email'].toString().toLowerCase().replace(/\s/g, '');
                    if (g.hasOwnProperty('Qrcode') && g['Qrcode'] === '') g['Qrcode'] = (Date.now().toString(36) + Math.random().toString(36).substr(2,3));
                    if (g.hasOwnProperty('Local/Oversea(local/oversea)') && g['Local/Oversea(local/oversea)'] === '') g['Local/Oversea(local/oversea)'] = 'local'; // default to 'local' if omitted
                    if (g.hasOwnProperty('Private account(yes/no)') && g['Private account(yes/no)'] === '') g['Private account(yes/no)'] = 'yes'; // default to 'yes' if omitted
                    if (g.hasOwnProperty('Notification(yes/no)') && g['Notification(yes/no)'] === '') g['Notification(yes/no)'] = 'yes'; // default to 'yes' if omitted
                    if (g.hasOwnProperty('Local/Oversea(local/oversea)')) g['Local/Oversea(local/oversea)'] = g['Local/Oversea(local/oversea)'].toString().toLowerCase().trim(); // trim whitespaces
                    if (g.hasOwnProperty('Private account(yes/no)')) g['Private account(yes/no)'] = g['Private account(yes/no)'].toString().toLowerCase().trim(); // trim whitespaces
                    if (g.hasOwnProperty('Notification(yes/no)')) g['Notification(yes/no)'] = g['Notification(yes/no)'].toString().toLowerCase().trim(); // trim whitespaces
                    
                    let $_EventGuest = new EventGuest();
                    $_EventGuest.companyId = companyId.value;
                    $_EventGuest.eventId = eventId.value;
                    $_EventGuest.username = g['Username'];
                    $_EventGuest.password = g['Password'] ? g['Password'] : '';
                    
                    let metadata = {...g};
                    // prepare standard fields & extra fields (i.e. metadata)
                    for (let colTitle in dbColMapping) {
                        if (g.hasOwnProperty(colTitle)) {
                            delete metadata[colTitle];
                            $_EventGuest[dbColMapping[colTitle]] = g[colTitle];
                        } else {
                            $_EventGuest[dbColMapping[colTitle]] = '';
                        }
                    }

                    if ($_EventGuest.hasOwnProperty('ev_profile_pic') && $_EventGuest['ev_profile_pic'] === '') delete $_EventGuest['ev_profile_pic'] // fallback to server default

                    $_EventGuest.metadata = JSON.stringify(metadata);
                    
                    let temp = await $_EventGuest.save().then(() => {
                        return false;
                    }, (e) => {
                        // root.$handleFeatherError(e);
                        return e.errors ? e.errors.map ? (e.errors.map(a => a.message)).join('; ') : e.message : e.statusText;
                    });
                    count++;
                    if (temp) {
                        errorMsg += '<li>Row #' + count + ' - ' + temp + '</li>';
                        errorCount++;
                    }
                }
                
                overlay.value = false;
                if (errorCount) {
                    dialogMsg.value = (count - errorCount) + ' of ' + count + ' Guest(s) sucessfully created.<br><br>' + (errorCount) + ' of ' + count + ' Guest(s) NOT created:<br><ul>' + errorMsg + '</ul>';
                    dialog.value = true;
                } else {
                    dialogMsg.value = '';
                    root.$store.dispatch('showSnackBar', 'Success. ' + count + ' Guest(s) Created.' + errorMsg);
                    root.$router.replace({name: 'event-guests'});
                }
            };
            
            // const usernameCol = ref('Email');
            // const usernameCol_items = computed(() => [
            //     ...colOptions.value
            // ]);
            
            // const passwordCol = ref('');
            // const passwordCol_items = computed(() => [
            //     {text: '(no password)', value: ''},
            //     ...colOptions.value
            // ]);
            
            const excelData_init = [{
                ...Object.keys(dbColMapping).reduce((reduced, key) => ({ ...reduced, [key]: '' }), {})
            }];
            const excelData = ref(JSON.parse(JSON.stringify(excelData_init)));
            
            const beforeSortColumn = (e) => {
                e.preventDefault();
            };
            
            const addGuest = () => {
                document.getElementById('excelGrid').addRow({});
            };
            
            const removeGuest = () => {
                let rowSelected = document.getElementById('excelGrid').selectedRows.map((row, j) => !!row && j).filter(j => j !== false && j >= 0).reverse();
                if (rowSelected.length >= 1 && document.getElementById('excelGrid').selections.every(row => !row || !row.length || row.length === document.getElementById('excelGrid').columnOrder.length + 1)) {
                    if (excelData.value.length - rowSelected.length >= 1) {
                        rowSelected.forEach(j => document.getElementById('excelGrid').deleteRow(j));
                    } else {
                        excelData.value = JSON.parse(JSON.stringify(excelData_init));
                    }
                } else {
                    root.$store.dispatch('showSnackBar', 'Please select entire row(s) by clicking row number.');
                }
            };
            
            return {
                eventSelected,
                eventOptions,
                companySelected,
                companyOptions,
                CanvasDatagrid,
                uploadExcel,
                excelData,
                importCheck,
                loadDataCheck,
                // passwordCol,
                // passwordCol_items,
                // usernameCol,
                // usernameCol_items,
                overlay,
                beforeSortColumn,
                addGuest,
                removeGuest,
                dialogMsg,
                dialog,

                excelInputEle
            }
        },
    }
</script>